import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UserActions, LeadActions } from '../../actions';

import { RegularPage } from '../Templates';
import {FormControl, Grid, InputLabel, Icon, Button, Paper, Select, CircularProgress, colors, Typography, MenuItem} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';

const styles = (theme) => ({
    grid: {
        padding: theme.spacing.unit * 3
    },
    paper: {
        margin: theme.spacing.unit * 2,
        width: '100%',
        padding: '2vw',
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    title: {
        marginBottom: '2vw',
        textAlign: 'left',
        width: '100%'
    },
    mainTitle: {
        fontSize: '2vw'
    },
    deleteButton: {
        margin: theme.spacing.unit,
    },
    saveButton: {
        width: '10%',
        display: 'flex'
    },
    selectUser: {
        width: '85%',
        display: 'block'
    },
    selectUserWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row'
    },
    fabProgress: {
        color: colors.green[500]
    }
});

class EditLeadPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userID: "",
            leadID: null,
            data: {},
            delete: false
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.changeUser = this.changeUser.bind(this);
        this.deleteLead = this.deleteLead.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const {leadID} = props.match.params;
        const nextState = {};

        if(!state.leadID) nextState.leadID = leadID;

        if(Object.is(nextState, {})) return null;
        return nextState;
    }

    componentDidMount() {
        const {dispatch} = this.props;
        dispatch(LeadActions.getAllLeads());
        dispatch(UserActions.getAllUsers());
    }

    componentDidUpdate(prevProps, prevState) {
        const {leads} = this.props;
        const {leadID, data} = this.state;

        if(leads && leads.list && leadID && !data._id) {
            const leadData = leads.list.find((item) => item._id === leadID);
            this.setState({
                userID: leadData.userID,
                data: leadData
            })
        } 
    }

    changeUser() {
        const {dispatch} = this.props;
        const {leadID, userID, data} = this.state;

        if(userID !== data.userID) {
            dispatch(LeadActions.updateLead(leadID, {
                userID: userID,
                interested: null, // clear for new user
                contact: false // clear for new user
            }));
        }
    }

    deleteLead() {
        const {dispatch} = this.props;
        const {leadID} = this.state;
        
        if(this.state.delete) {
            dispatch(LeadActions.deleteLead(leadID));
        } else {
            this.setState({delete: true});
        }
    }

    handleSelectChange(e) {
        this.setState({userID: e.target.value});
    }

    render() {
        const {classes, users, leads} = this.props;
        const {leadID, userID} = this.state;

        const updateProcess = leads && leadID && leads.updateLeadProcessList && leads.updateLeadProcessList[leadID];
        const deleteProcess = leads && leadID && leads.deleteLeadProcessList && leads.deleteLeadProcessList[leadID];

        let allUsers = null;
        if(users && users.list) {
            allUsers = users.list.map((item) => (
                <MenuItem key={item._id} value={item._id}>
                    {`${item.name} - ${item.email}`}
                </MenuItem>
            ));
        }

        return (
            <RegularPage>
                <Typography variant="title" className={classes.mainTitle}>
                    <strong>Edit lead ID:</strong> {leadID}&nbsp;
                    <Button 
                        variant="outlined" 
                        size="small" 
                        className={classes.deleteButton}
                        disabled={deleteProcess}
                        onClick={this.deleteLead}
                    >
                        {!deleteProcess ?
                            this.state.delete ? 'sure?' : <Icon >delete</Icon> :
                            <CircularProgress size={20} className={classes.fabProgress}/>
                        }
                    </Button>
                </Typography>
                <Grid className={classes.grid} container>
                    <Paper className={classes.paper}>
                        <Typography variant="title" className={classes.title}>
                            Change user
                        </Typography>
                        <FormControl fullWidth className={classes.selectUserWrapper}>
                            <InputLabel htmlFor="select-user">Select user</InputLabel>
                            <Select
                                value={userID}
                                onChange={this.handleSelectChange}
                                displayEmpty
                                className={classes.selectUser}
                                inputProps={{
                                    name: 'User',
                                    id: 'select-user',
                                }}
                            >
                                {allUsers}
                            </Select>
                            <Button 
                                variant="contained" 
                                color="secondary" 
                                className={classes.saveButton} 
                                onClick={this.changeUser}
                                disabled={updateProcess}
                            >
                                {updateProcess ? <CircularProgress size={20} className={classes.fabProgress}/> : <Icon>save</Icon>}
                            </Button>
                        </FormControl>
                    </Paper>
                </Grid>
            </RegularPage>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        users: state.userReducer,
        leads: state.leadReducer
    }
}

const EditLeadPageWithRedux = withRouter(withStyles(styles)(connect(mapStateToProps)(EditLeadPage)));

export {EditLeadPageWithRedux as EditLeadPage};


// WEBPACK FOOTER //
// ./src/components/LeadsPage/EditLeadPage.jsx